import { render, staticRenderFns } from "./ProcessListGroups.vue?vue&type=template&id=36776ffb&scoped=true&"
import script from "./ProcessListGroups.vue?vue&type=script&lang=js&"
export * from "./ProcessListGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36776ffb",
  null
  
)

export default component.exports